<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style src="./macrofox.css"></style>
<style src="./macrofox.app.css"></style>
<style src="./macrofox.icons.css"></style>